// Boards: SignIn, SignInNotInvited and their round 1 pairs (the globe in the top corner: LanguageMenu). The page sets the direction.
import React from 'react';
import { t } from '../../i18n';
import LanguageMenu from './LanguageMenu';
import { GeneralError, GoogleMark, Logo, WarnIcon, Wordmark, onTap } from './parts';

export default function SignIn({ notInvited, error, onGoogle, onJoinWithCode }) {
  return (
    <main className="screen">
      <div className="body" style={{ gap: 18, paddingTop: 120, paddingBottom: 40 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <Logo width="112" height="96" />
          <h1 style={{ margin: 0, font: '400 52px/1 var(--display)', textAlign: 'center' }}><Wordmark accent="#ee5a4a" /></h1>
        </div>
        <p className="h-m" style={{ textAlign: 'center' }}>
          {t('signIn.lead').split('\n').map((line, i) => <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>)}
        </p>
        <div style={{ flex: 1 }}></div>
        {notInvited && <div className="err" role="alert"><WarnIcon />{t('signIn.notInvited')}</div>}
        <a className="btn btn-sso btn-block" href="#google" onClick={onTap(onGoogle)}><GoogleMark />{t('signIn.google')}</a>
        {error && <GeneralError />}
        {notInvited && <a className="btn btn-block" href="#guest" onClick={onTap(onJoinWithCode)}>{t('signIn.joinWithCode')}</a>}
      </div>
      <LanguageMenu corner />
    </main>
  );
}
